const state = {
  data: {},
};
export default {
  state,
  mutations: {
    setParams(state, obj) {
      state.data = { ...obj };
    },
  },
  actions: {
    setParams({ commit }, obj) {
      commit('setParams', obj)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/isPrivate/index.js